"use strict";

var _classCallCheck = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attractor = void 0;

var Utils_1 = require("../../../../Utils");

var Attractor = /*#__PURE__*/function () {
  function Attractor(container) {
    _classCallCheck(this, Attractor);

    this.container = container;
  }

  _createClass(Attractor, [{
    key: "interact",
    value: function interact(p1) {
      var _a;

      var container = this.container;
      var options = container.options;
      var distance = (_a = p1.linksDistance) !== null && _a !== void 0 ? _a : container.retina.linksDistance;
      var pos1 = p1.getPosition();
      var query = container.particles.quadTree.query(new Utils_1.Circle(pos1.x, pos1.y, distance));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p2 = _step.value;

          if (p1 === p2 || p2.particlesOptions.move.attract.enable) {
            continue;
          }

          var pos2 = p2.getPosition();

          var _Utils_1$Utils$getDis = Utils_1.Utils.getDistances(pos1, pos2),
              dx = _Utils_1$Utils$getDis.dx,
              dy = _Utils_1$Utils$getDis.dy;

          var rotate = options.particles.move.attract.rotate;
          var ax = dx / (rotate.x * 1000);
          var ay = dy / (rotate.y * 1000);
          p1.velocity.horizontal -= ax;
          p1.velocity.vertical -= ay;
          p2.velocity.horizontal += ax;
          p2.velocity.vertical += ay;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.particlesOptions.move.attract.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Attractor;
}();

exports.Attractor = Attractor;